<div class="row">
  <div class="col-lg-12 col-sm-12 col-md-12 header-center">
    <table>
      <tr>
        <td>
          <img src="assets/images/PanadolLogo1x.png" class="header-logo" />
        </td>
        <td class="header-title">
          <strong>Paracetamol suitability in various patients types</strong>
        </td>
      </tr>
    </table>
  </div>


</div>



<div class="row">
  <div class="col-lg-12">
    <div class="table-container" style="width:100%;visibility: hidden;">
      <table style="width:100%;table-layout:fixed">
        <tr>
          <td style="width: 74px;vertical-align: top;position: relative;left: 5px;">
            <div class="row scrollable" style="display: flex;">
              <div class="left-header">
                <div class="bg-blue row-1"></div>
                <div class="bg-blue row-2" style="height:135px;">Paracetamol</div>
                <div class="bg-blue row-3" style="height:82px;">Ibuprofen</div>
                <div class="bg-blue row-4" style="height:80px;">Aspirin</div>
                <div class="bg-blue row-5" style="height:80px;">Naproxen</div>
              </div>
            </div>
          </td>
          <td style="vertical-align:top">
            <!-- scrollable right side content -->
            <div class="right-side" style="width:100%;">
              <div class="top-header" style="table-layout:fixed;width:100%">
                <div class="row scrollable" style="display: flex;">
                  <div id="parent-div-2" class="column">
                    <div class="row-1">Patients with <br />gastrointestinal <br />symptoms</div>
                    <div class="bg-green table-text-color row-2">
                      <div>
                        <img src="assets/images/tick.png" style="max-width: 30px;" class="table-icon" /><br />
                        Preferred treatment:<br />
                        (American College of<br />
                        Gastroenterology, 2016)<br />
                        Graham, 2005,<br />
                        Lewis 2002, Blot 2000;<br />
                        Garcia-Rodriguez, 2001
                      </div>
                    </div>
                    <div class="row-3 bg-yellow table-text-color">
                      <div>
                        At low doses ibuprofen<br />
                        has a good safety profile<br />
                        comparable with<br />
                        paracetamol (Rainsford<br />
                        KD 2009)<br /><br />
                        Higher doses may<br />
                        heighten the risk of GI<br />
                        injury.<br />
                        (Sachs CJ 2005)
                      </div>
                    </div>
                    <div class="row-4 bg-pink table-text-color">
                      <div>
                        Caution<br /><br />
                        Higher incidence of<br />
                        gastrointestinal adverse<br />
                        events.<br /><br />
                        Avoid in patients with<br />
                        active peptic ulcer<br />
                        disease.
                      </div>
                    </div>
                    <div class="row-5 bg-pink table-text-color">
                      <div>
                        Caution<br /><br />
                        Increased risk of<br />
                        serious GI adverse<br />
                        events
                      </div>
                    </div>
                  </div>
                  <div id="parent-div-3" class="column">
                    <div class="row-1">Patients with <br />Asthma</div>
                    <div class="bg-green table-text-color row-2">
                      <div style="vertical-align: top;height: 70%;">
                        <img src="assets/images/tick.png" style="max-width: 30px;" class="table-icon" /><br />
                      </div>
                    </div>
                    <div class="row-3 bg-pink table-text-color">
                      <div>
                        Should be used with<br />
                        caution in patients with<br />
                        preexisting asthma.
                      </div>
                    </div>
                    <div class="row-4 bg-pink table-text-color">
                      <div>
                        Use of aspirin in<br />
                        patients with aspirinsensitive<br />
                        asthma has<br />
                        been associated with<br />
                        severe bronchospasm
                      </div>
                    </div>
                    <div class="row-5 bg-pink table-text-color">
                      <div>
                        Should be used with<br />
                        caution in patients with<br />
                        preexisting asthma.
                      </div>
                    </div>
                  </div>
                  <div id="parent-div-4" class="column">
                    <div class="row-1">Kidney <br />impairment/ <br />disorder</div>
                    <div class="bg-green table-text-color row-2">
                      <div style="vertical-align: top;height: 70%;">
                        <img src="assets/images/tick.png" style="max-width: 30px;" class="table-icon" /><br />
                      </div>
                    </div>
                    <div class="row-3 bg-yellow table-text-color">
                      <div>
                        Caution<br /><br />
                        Increased risk of causing<br />
                        renal impairment at high<br />
                        doses, especially among<br />
                        elderly patients or<br />
                        patients with reduced<br />
                        renal function.
                      </div>
                    </div>
                    <div class="row-4 bg-pink table-text-color">
                      <div>
                        Caution<br /><br />
                        Avoid in patients with<br />
                        GFR &lt;10 mL /minute
                      </div>
                    </div>
                    <div class="row-5 bg-pink table-text-color">
                      <div>
                        Caution<br /><br />
                        May precipitate acute<br />
                        renal failure in patients<br />
                        with congestive cardiac<br />
                        failure and pre-existing<br />
                        renal impairment
                      </div>
                    </div>
                  </div>
                  <div id="parent-div-5" class="column">
                    <div class="row-1">Elderly</div>
                    <div class="bg-green table-text-color row-2">
                      <div style="vertical-align: top;height: 70%;">
                        <img src="assets/images/tick.png" style="max-width: 30px;" class="table-icon" /><br />
                      </div>
                    </div>
                    <div class="bg-yellow table-text-color row-3">
                      <div>
                        Caution<br /><br />
                        Risk of GI bleeding<br />
                        increases in people<br />
                        aged 60 years or<br />
                        older
                      </div>
                    </div>
                    <div class="row-4 bg-pink table-text-color">
                      <div>
                        Not recommended for<br />
                        primary prevention in<br />
                        adults &gt;70 years of age<br />
                        as the risk of major<br />
                        bleeding is likely to<br />
                        overweigh the potential<br />
                        benefit in reducing<br />
                        CV events
                      </div>
                    </div>
                    <div class="row-5 bg-pink table-text-color">
                      Caution
                    </div>
                  </div>
                  <div id="parent-div-6" class="column">
                    <div class="row-1">Patients with <br />hypertension</div>
                    <div class="bg-green table-text-color row-2">
                      <div style="vertical-align: top;height: 70%;">
                        <img src="assets/images/tick.png" style="max-width: 30px;" class="table-icon" /><br />
                        Fulton 2015
                      </div>
                    </div>
                    <div class="row-3 bg-yellow table-text-color">
                      <div>
                        Should be used with<br />
                        caution in patients with<br />
                        hypertension.
                      </div>
                    </div>
                    <div class="row-4 bg-pink table-text-color">
                      <div>Caution</div>
                    </div>
                    <div class="row-5 bg-pink table-text-color">
                      <div>
                        Caution<br /><br />
                        BP monitoring needed
                      </div>
                    </div>
                  </div>
                  <div id="parent-div-7" class="column">
                    <div class="row-1">Patients with <br />cardiovascular (CV) <br />complications and <br />Diabetes*
                    </div>
                    <div class="bg-green table-text-color row-2">
                      <div>
                        <img src="assets/images/tick.png" style="max-width: 30px;" class="table-icon" /><br />
                        (1st step: AHA/ACC<br />
                        recommendation)<br /><br />
                        (Antman, 2007, Fulton,<br />
                        2015, Amsterdam, 2014)
                      </div>
                    </div>
                    <div class="row-3 bg-yellow table-text-color">
                      <div>
                        When used at low doses<br />
                        according to label<br />
                        directions, cardiovascular<br />
                        risk is minimal.<br /><br />
                        High doses over<br />
                        prolonged periods can<br />
                        increase the risk of<br />
                        developing CV events.
                      </div>
                    </div>

                    <div class="row-4 bg-green table-text-color">
                      <div>
                        Use aspirin therapy<br />
                        (75–162 mg/day) as a<br />
                        secondary prevention<br />
                        strategy in those with<br />
                        diabetes and a history<br />
                        of atherosclerotic CVD<br />
                        is recommended
                      </div>
                    </div>
                    <div class="row-5 bg-pink table-text-color">
                      <div>
                        Caution<br /><br />
                        Avoid in patients with<br />
                        recent MI and<br />
                        heart failure
                      </div>
                    </div>
                  </div>
                  <div id="parent-div-8" class="column">
                    <div class="row-1">Patients on multiple <br />medications</div>
                    <div class="bg-green table-text-color row-2">
                      <div>
                        With the exception of<br />
                        warfarin, there are very<br />
                        few clinically significant<br />
                        drug interactions with<br />
                        paracetamol.<br /><br />
                        Toes, 2005
                      </div>
                    </div>
                    <div class="row-3 bg-yellow table-text-color">
                      <div>
                        Concomitant<br />
                        administration of<br />
                        Ibuprofen and<br />
                        aspirin is not generally<br />
                        recommended because<br />
                        of the potential for<br />
                        increased adverse effects.<br /><br />
                        May interact with<br />
                        CV drugs (ACE inhibitors,<br />
                        diuretics)
                      </div>
                    </div>
                    <div class="row-4 bg-pink table-text-color">
                      <div>
                        Caution<br /><br />
                        Significant interaction<br />
                        with furosemide,<br />
                        atenolol,<br />
                        spironolactone and<br />
                        digoxin
                      </div>
                    </div>
                    <div class="row-5 bg-pink table-text-color">
                      <div>
                        Caution<br /><br />
                        May interact with<br />
                        CV drugs<br />
                        (ACE inhibitors, diuretics)
                      </div>
                    </div>
                  </div>
                  <div id="parent-div-9" class="column">
                    <div class="row-1">Infants/children</div>
                    <div class="bg-green table-text-color row-2">
                      <div>
                        Suitable for children<br />
                        &lt; 1 month old<br /><br />
                        <a style="line-height:0px;text-decoration: none !important;color:#124982" target="_blank"
                          href="https://www.drugs.com/paracetamol.html">https://www.drugs.com<br />/paracetamol.html</a>
                      </div>
                    </div>
                    <div class="row-3 bg-yellow table-text-color">
                      <div>
                        Suitable for children<br />
                        &gt; 6 months of age
                      </div>
                    </div>
                    <div class="row-4 bg-pink table-text-color">
                      <div>
                        Should be avoided in<br />
                        children under the<br />
                        age of 12 years
                      </div>
                    </div>
                    <div class="row-5 bg-pink table-text-color">
                      <div>
                        Should be avoided in<br />
                        children under the<br />
                        age of 12 years
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>


<div class="row" style="margin-top:5px;">
  <div class="col-lg-9" style="font-family:OpenSansRegular;font-size:9px;color:#124982;">
    In the table Cardioavascular complications mean risk of MI or stroke or any cardiovascular event
  </div>
</div>

<div class="row" style="margin-top:50px;">
  <div class="col-lg-9" style="font-family:OpenSansRegular;font-size:9px;color:#124982;">
    *Panadol Advance is more rapidly absorbed than Panadol base tablets even in patients with diabetes with delayed
    gastric emptying – Horowitz-2001 Dec;15(12):805-13
  </div>
  <div class="col-lg-3">
    <div style="float: right;">
      <div class="legend-icon bg-green" (click)="active = 1" (mouseover)="active = 1" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 1">
          <img class="popup-suit-green-tick" />
        </div>
      </div>
      <div class="legend-icon bg-yellow" (click)="active = 2" (mouseover)="active = 2" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 2">
          <img class="popup-panadol-yellow-tick" />
        </div>
      </div>
      <!-- <div class="legend-icon bg-pink" (click)="active = 3" (mouseover)="active = 3" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 3">
          <img class="popup-panadol-pink" />
        </div>
      </div> -->
      <div class="legend-icon bg-pink" (click)="active = 4" (mouseover)="active = 4" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 4">
          <img class="popup-panadol-gray-tick" />
        </div>
      </div>
    </div>

  </div>
</div>
